<script>
import axios from 'axios';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import downloader from '../../mixins/downloader';
import Quiz from './components/Quiz';

export default {
  name: 'Training',
  components: {
    Quiz,
  },
  mixins: [mainViewTabMixin, snackbarMixin, downloader],
  data() {
    return {
      areQuestionsDisplayed: false,
      isSuccessPageDisplayed: false,
      isError: false,
      isLoading: true,
      training: {},
    };
  },
  created() {
    axios.get('/user?current=true')
      .then((res) => {
        this.isSuccessPageDisplayed = !!res.data.trainedDate;
      })
      .catch(() => {
        this.isError = true;
      })
      .finally(() => {
        if (!this.isSuccessPageDisplayed) {
          axios.get('/training?current=true')
            .then((res) => {
              this.training = res.data;
            })
            .catch(() => {
              this.isError = true;
            })
            .finally(() => {
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
  },
  methods: {
    getCert() {
      this.download('/training/cert/', 'Datenschutz_Zertifikat.pdf');
    },
    embedVideoUrl(url) {
      if (!url) return url;
      try {
        const u = new URL(url);
        const host = u.hostname.replace(/^www\./, '');

        if (host === 'youtube.com' && u.pathname.startsWith('/embed/')) {
          return url;
        }
        if (host === 'youtu.be') {
          const id = u.pathname.slice(1).split('/')[0];
          if (id) return `https://www.youtube.com/embed/${id}`;
        }
        if (host === 'youtube.com' && u.pathname === '/watch') {
          const id = u.searchParams.get('v');
          if (id) return `https://www.youtube.com/embed/${id}`;
        }
        if (host === 'youtube.com' && u.pathname.startsWith('/shorts/')) {
          const id = u.pathname.split('/').filter(Boolean)[1];
          if (id) return `https://www.youtube.com/embed/${id}`;
        }
      } catch (e) {
        return url;
      }

      return url;
    },
  },
};
</script>

<template>
  <div>
    <div v-if="isError">
      <v-flex xs12 md12>&nbsp;</v-flex>
      <v-flex xs12 md12 ><div style="color: #D32F2F;">
        Ein Fehler ist aufgetreten. Versuchen Sie es später erneut.</div>
      </v-flex>
    </div>
    <div v-else-if="isLoading"/>
    <div v-else-if="isSuccessPageDisplayed">
      <v-layout row wrap>
        <v-flex xs12 md12>&nbsp;</v-flex>
        <v-flex xs12 md12 ><div style="color: #388E3C;">
          Herzlichen Glückwunsch! Sie haben die Datenschutzschulung erfolgreich abgeschlossen.
          Sie können sich jetzt Ihr Zertifikat herunterladen.</div>
        </v-flex>
        <v-flex xs12 md12>&nbsp;</v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-btn @click.native="getCert()"
               color="blue"
               flat>
          Zertifikat herunterladen
        </v-btn>
      </v-layout>
    </div>
    <div v-else-if="!areQuestionsDisplayed">
      <div v-if="training.videoUrl">
        <v-layout row wrap>
          <v-flex xs12 md12>&nbsp;</v-flex>
          <v-flex xs12 md12>
            Sehen Sie sich das Schulungsvideo aufmerksam an.
            Im Anschluss wird Ihr Wissen mit Fragen geprüft.
          </v-flex>

          <v-flex xs12 md12>&nbsp;</v-flex>

          <div id="training-player">
            <!--<iframe
              width="854" height="480"
              src="https://vimeo.com/321813865"
              />-->
            <iframe
              :src="embedVideoUrl(training.videoUrl)"
              width="800" height="450" frameborder="0"
              webkitallowfullscreen mozallowfullscreen allowfullscreen
            />
            <!-- <iframe
              src="https://player.vimeo.com/video/337956163"
              width="800" height="450"
              frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
              /> -->
          </div>
        </v-layout>

        <v-btn flat slot="activator" @click="areQuestionsDisplayed = true">
          Zu den Fragen
        </v-btn>
      </div>
      <div v-else>
        <quiz
          :training="training"
          @reset="areQuestionsDisplayed = false"
          @success="isSuccessPageDisplayed = true"
        />
      </div>

    </div>
    <div v-else>
      <quiz
        :training="training"
        @reset="areQuestionsDisplayed = false"
        @success="isSuccessPageDisplayed = true"
      />
    </div>
  </div>
</template>
